if (!customElements.get('newsletter-modal')) {
  customElements.define('newsletter-modal', class NewsletterModal extends HTMLElement {
    constructor() {
      super();
      this.currentStep = 1;
    }

    connectedCallback() {
      // Run init immediately
      this.init();
      
      // Run init AGAIN after a short delay (Safety backup for slow themes)
      setTimeout(() => this.recheckInit(), 500);

      this.setupEvents();
    }

    init() {
      // 1. CHECK FOR "REOPEN" FLAG (Local Storage)
      if (localStorage.getItem('peak_reopen') === 'true') {
        console.log("Peak Popup: Found reopen flag. Opening Step 3.");
        
        // Remove flag so it doesn't loop forever
        localStorage.removeItem('peak_reopen');
        
        this.show();
        this.goToStep(3); 
        return; 
      }

      // 2. CHECK URL PARAMETER (Shopify Fallback)
      if (window.location.search.includes('customer_posted=true')) {
        console.log("Peak Popup: Found URL parameter. Opening Step 3.");
        this.show();
        this.goToStep(3); 
        return;
      }

      // 3. STANDARD SHOW LOGIC
      const seen = document.cookie.includes('nuataaq_popup_seen=true');
      const testMode = this.getAttribute('data-test-mode') === 'true';
      const delay = parseInt(this.getAttribute('data-delay')) || 5;

      if (!seen || testMode) {
        // Only queue if we haven't already opened via the flag
        if (this.style.display !== 'flex') {
          console.log(`Peak Popup: Queuing standard show in ${delay}s.`);
          setTimeout(() => this.show(), delay * 1000);
        }
      }
    }

    recheckInit() {
      // A secondary check in case the first one ran too early
      if (localStorage.getItem('peak_reopen') === 'true') {
         this.init();
      }
    }

    show() {
      // If already open, do nothing
      if (this.style.display === 'flex') return;

      this.style.display = 'flex'; 
      this.startTimer();

      // GA4: Impression
      if (typeof gtag !== 'undefined') {
        gtag('event', 'popup_impression', {
          'event_category': 'engagement',
          'event_label': 'newsletter_popup'
        });
      }
    }

    hide() {
      this.style.display = 'none';
      document.cookie = "nuataaq_popup_seen=true; max-age=2592000; path=/";
    }

    setupEvents() {
      this.querySelectorAll('.peak-close, .close-trigger').forEach(btn => {
        btn.onclick = (e) => { e.preventDefault(); this.hide(); };
      });

      const nextBtn = this.querySelector('[data-action="next-step"]');
      if(nextBtn) nextBtn.onclick = () => this.goToStep(2);

      const emailBtn = this.querySelector('[data-action="submit-email"]');
      if(emailBtn) {
        emailBtn.onclick = (e) => {
          e.preventDefault();
          this.validateAndSubmit();
        };
      }
      
      const emailInput = this.querySelector('#PeakEmailInput');
      if(emailInput) {
        emailInput.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') { e.preventDefault(); this.validateAndSubmit(); }
        });
        emailInput.addEventListener('input', () => emailInput.classList.remove('input-error'));
      }

      const miniBtns = this.querySelectorAll('[data-action="next-mini"]');
      miniBtns.forEach(btn => btn.onclick = () => this.goToStep(this.currentStep + 1));

      const copyBtn = this.querySelector('[data-action="copy-code"]');
      if(copyBtn) {
        copyBtn.onclick = () => {
          const code = this.querySelector('#DiscountCode').innerText;
          navigator.clipboard.writeText(code);
          copyBtn.innerText = 'COPIED!';
          setTimeout(() => copyBtn.innerText = 'COPY', 2000);
        };
      }

      const shopBtn = this.querySelector('.peak-shop-now');
      if(shopBtn) {
        shopBtn.onclick = (e) => {
          e.preventDefault();
          this.hide(); 
        };
      }
    }

    validateAndSubmit() {
      const input = this.querySelector('#PeakEmailInput');
      const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value);
      
      if (input && isValid) {
        
        // GA4: Track Lead
        if (typeof gtag !== 'undefined') {
          gtag('event', 'generate_lead', {
            'source': 'newsletter_popup',
            'currency': 'USD'
          });
        }

        // === SET REOPEN FLAG ===
        console.log("Peak Popup: Setting reopen flag and submitting...");
        localStorage.setItem('peak_reopen', 'true');

        // === STANDARD SUBMIT ===
        // This avoids "Invalid Parameters"
        this.querySelector('form')?.submit();
        
      } else {
        input.classList.add('input-error');
        input.focus();
      }
    }

    autoApplyDiscount() {
      const codeSpan = this.querySelector('#DiscountCode');
      if (!codeSpan) return;
      const code = codeSpan.innerText.trim();
      if (!code) return;

      fetch(`/discount/${code}`)
        .then(() => console.log(`Discount ${code} applied.`))
        .catch(e => console.error('Failed to apply discount', e));
    }

    goToStep(step) {
      this.currentStep = step;
      this.querySelectorAll('.peak-step').forEach(el => el.classList.remove('active'));
      const next = this.querySelector(`[data-step="${step}"]`);
      if(next) next.classList.add('active');

      if (step >= 3) {
        const container = this.querySelector('.peak-container');
        container.classList.add('peak-minimized');
        const bgWrapper = this.querySelector('.peak-bg-wrapper');
        if(bgWrapper) bgWrapper.style.display = 'none';

        this.style.pointerEvents = 'none'; 
        container.style.pointerEvents = 'auto'; 
      }

      if (step === 5) {
        this.autoApplyDiscount();
      }
    }

    startTimer() {
      let sec = 30;
      const el = this.querySelector('#peak-timer');
      if(!el) return;
      
      if(this.timerInterval) clearInterval(this.timerInterval);

      this.timerInterval = setInterval(() => {
        sec--;
        const formattedSec = sec < 10 ? `0${sec}` : sec;
        el.textContent = `0:${formattedSec}`;
        
        if(sec <= 0) {
           el.textContent = "0:00";
           clearInterval(this.timerInterval);
        }
      }, 1000);
    }
  });
}